const mainUrl = `${process.env.VUE_APP_API_URL}/api`
export default mainUrl
